import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mt-5" }
const _hoisted_4 = { class: "table_style" }
const _hoisted_5 = { class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-4" }
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "pagination-mini" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = ["disabled"]

import {
  ref,
  reactive,
  computed,
  onMounted,
  watch,
  defineAsyncComponent,
} from "vue";
import { useRouter } from "vue-router";
import apiService from "@/services/apiService";
import CommonTable2 from "@/components/commen/table/CommonTable2.vue";
import TableTitle from "@/components/commen/table/TableTitle.vue";
import { toast } from "vue3-toastify";
import { usePermissions } from "@/composables/usePermissions";

interface Filters {
  status: string;
  category: string;
  is_featured: string;
}
// Filters

export default /*@__PURE__*/_defineComponent({
  __name: 'KnowlegeList',
  setup(__props) {

const { canView, canCreate, canUpdate, canDelete } = usePermissions();
const KnowledgeModal = defineAsyncComponent(
  () => import("@/components/theme/admin/knowledge/KnowledgeModal.vue")
);
const KnowledgeViewModal = defineAsyncComponent(
  () => import("@/components/theme/admin/knowledge/KnowledgeViewModal.vue")
);

const router = useRouter();
const loading = ref(false);
const blogs = ref([]);
const categories = ref([]);
const selectedBlog = ref(null);
const showModal = ref(false);
const showViewModal = ref(false);
const rows = ref([]);
const searchQuery = ref("");

const filters = reactive<Filters>({
  status: "",
  category: "",
  is_featured: "",
});

// pagination
const currentPage = ref(1);
const tablePagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
});

const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;

  // If total pages small → show all
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  let pages: any[] = [];

  // Always show first page
  pages.push(1);

  // Left side "..."
  if (current > 4) {
    pages.push("...");
  }

  // Middle window (current -1, current, current +1)
  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);

  for (let i = windowStart; i <= windowEnd; i++) {
    pages.push(i);
  }

  // Right side "..."
  if (current < total - 3) {
    pages.push("...");
  }

  // Always show last page
  pages.push(total);

  return pages;
});
const changeRows = () => {
  currentPage.value = 1;
  fetchBlogs();
};
watch(
  () => tablePagination.value,
  (newVal) => {
    tableConfig.value.pagination = newVal;
  },
  { deep: true }
);

const resetFilters = () => {
  Object.keys(filters).forEach((key) => {
    (filters as any)[key] = "";
  });
  searchQuery.value = "";
  currentPage.value = 1; // RESET PAGE
};

// FETCH BLOGS (NO PAGINATION)
// Methods
const fetchBlogs = async () => {
  try {
    loading.value = true;
    const params: Record<string, any> = {
      page: currentPage.value,
      limit: tablePagination.value.per_page,
      search: searchQuery.value,
      ...filters,
    };

    // Remove empty filters
    Object.keys(params).forEach((key) => {
      if (
        params[key] === "" ||
        params[key] === null ||
        params[key] === undefined
      ) {
        delete params[key];
      }
    });

    const response = await apiService.getKnowledge(params);
    blogs.value = response.data || [];
    tablePagination.value = {
      current_page: response.pagination?.current_page || 1,
      per_page: params.limit,
      total: response.pagination?.total || 0,
      total_pages: response.pagination?.total_pages || 1,
      has_next: response.pagination?.has_next || false,
      has_prev: response.pagination?.has_prev || false,
    };
  } catch (error) {
    console.error("Error fetching blogs:", error);
    blogs.value = [];
  } finally {
    loading.value = false;
  }
};
// const fetchBlogs = async () => {
//   try {
//     loading.value = true;
//     const response = await apiService.getKnowledge();
//     blogs.value = response.data || [];
//   } catch (error) {
//     console.error("Error fetching blogs:", error);
//     blogs.value = [];
//   } finally {
//     loading.value = false;
//   }
// };

// FETCH CATEGORIES
const fetchCategories = async () => {
  try {
    const response = await apiService.getKnowledgeCategories({});
    categories.value = response.data || response || [];
    console.log(categories.value, "these are all categories");
  } catch (error) {
    categories.value = [];
  }
};

const openCreateModal = () => {
  selectedBlog.value = null;
  showModal.value = true;
};

const editBlog = (id: string) => {
  router.push(`/knowledge/${id}/edit`);
};

const viewBlog = (row: any) => {
  const article = blogs.value.find((b) => b._id === row._id);
  selectedBlog.value = article || row;
  showViewModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedBlog.value = null;
};

const closeViewModal = () => {
  showViewModal.value = false;
  selectedBlog.value = null;
};

const editFromView = (article: any) => {
  closeViewModal();
  router.push(`/knowledge/${article._id}/edit`);
};

const handleBlogSaved = () => {
  closeModal();
  fetchBlogs();
};

// Featured toggle
const toggleFeatured = async (id: string) => {
  try {
    const blog = blogs.value.find((b) => b._id === id);
    if (blog) blog.is_featured = !blog.is_featured;

    await apiService.toggleKnowledgeFeatured(id);
    toast.success(
      `Article ${ blog.is_featured ? "marked as featured" : "removed from featured"}`
    );
    fetchBlogs();
  } catch (error) {
    const blog = blogs.value.find((b) => b._id === id);
    if (blog) blog.is_featured = !blog.is_featured;
  }
};
const handleStatusFilter = (val: string) => {
  filters.status = val.toLowerCase();
  currentPage.value = 1; // RESET PAGE
};

const handleCategoryFilter = (id: string) => {
  filters.category = id;
  currentPage.value = 1; // RESET PAGE
};

const publishBlog = async (id: string) => {
  await apiService.publishKnowledge(id);
  fetchBlogs();
};

const unpublishBlog = async (id: string) => {
  await apiService.unpublishKnowledge(id);
  fetchBlogs();
};

const deleteBlog = async (id: string) => {
  if (confirm("Delete this article?")) {
    await apiService.deleteKnowledge(id);
    fetchBlogs();
  }
};

watch(
  [filters],
  () => {
    fetchBlogs();
  },
  { deep: true }
);

// Load on mount
onMounted(() => {
  fetchCategories();
  fetchBlogs();
});

// table config
const tableConfig = ref({
  columns: [
    { name: "Image", field: "featured_image", width: "auto" },
    { name: "Title", field: "title", sortable: true, width: "auto" },
    { name: "Category", field: "category", width: "auto" },
    { name: "Author", field: "author", width: "auto" },
    { name: "Status", field: "status", width: "auto" },
    { name: "Views", field: "views", width: "auto" },
    { name: "Featured", field: "featured", width: "auto" },
    { name: "Published", field: "published", width: "auto" },
  ],
  data: rows,
  actions: [true],
  loading: loading,
  categories: categories,
  pagination: tablePagination,
  showCategoryFilter: true,
  showStatusFilter: true,
  showResetFilter: true,
  table_width: "1500px",
  allStatusLables: ["Draft", "Published", "Scheduled", "Archived"],
});

const handlePageChange = (page) => {
  currentPage.value = page;
  fetchBlogs();
};

watch(
  blogs,
  (newVal) => {
    rows.value = newVal.map((item) => ({
      featured_image: item.featured_image,
      title: item.title,
      category: {
        id: item.category_id._id,
        title: item.category_id.title,
      },
      author: item.author?.name || "",
      published: item.published_at
        ? new Date(item.published_at).toLocaleDateString()
        : "Not published",
      views: {
        view_count: item.view_count,
        like_count: item.like_count,
        share_count: item.share_count,
      },
      status: item.status,
      _id: item._id,
      is_featured: item.is_featured,
      isBlog: true,
    }));
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(TableTitle, {
            title: "Knowledge Articles List",
            pageTitle: "Knowledge",
            icon: "fas fa-book",
            showAction: true,
            actionLabel: "Create Article",
            onAction: openCreateModal,
            disabled: !_unref(canCreate)('website')
          }, null, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(CommonTable2, {
              tableObj: tableConfig.value,
              onEdit: editBlog,
              onDelete: deleteBlog,
              onView: viewBlog,
              onToggleFeatured: toggleFeatured,
              onPublish: publishBlog,
              onUnPublish: unpublishBlog,
              onStatusFilter: handleStatusFilter,
              onCategoryFilter: handleCategoryFilter,
              onResetFilters: resetFilters,
              onPageChanged: handlePageChange,
              permissionKey: "website"
            }, null, 8, ["tableObj"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm rows-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tablePagination.value.per_page) = $event)),
                onChange: changeRows
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                  return _createElementVNode("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_7)
                }), 64))
              ], 544), [
                [_vModelSelect, tablePagination.value.per_page]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "page-btn prev_btn",
                disabled: !tablePagination.value.has_prev,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePageChange(tablePagination.value.current_page - 1)))
              }, " « ", 8, _hoisted_9),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  class: _normalizeClass(["page-btn", {
                  'page-active': p === tablePagination.value.current_page,
                  'disabled-dots': p === '...',
                }]),
                  disabled: p === '...',
                  onClick: ($event: any) => (p !== '...' && handlePageChange(p))
                }, _toDisplayString(p), 11, _hoisted_10))
              }), 128)),
              _createElementVNode("button", {
                class: "page-btn next_btn",
                disabled: !tablePagination.value.has_next,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePageChange(tablePagination.value.current_page + 1)))
              }, " » ", 8, _hoisted_11)
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(KnowledgeModal), {
          key: 0,
          show: showModal.value,
          article: selectedBlog.value,
          categories: categories.value,
          onClose: closeModal,
          onSaved: handleBlogSaved
        }, null, 8, ["show", "article", "categories"]))
      : _createCommentVNode("", true),
    (showViewModal.value)
      ? (_openBlock(), _createBlock(_unref(KnowledgeViewModal), {
          key: 1,
          show: showViewModal.value,
          article: selectedBlog.value,
          categories: categories.value,
          onClose: closeViewModal,
          onEdit: editFromView
        }, null, 8, ["show", "article", "categories"]))
      : _createCommentVNode("", true)
  ]))
}
}

})